// extracted by mini-css-extract-plugin
export var msg = "styles-module--msg--5aJ70";
export var info = "styles-module--info--EoLCZ";
export var success = "styles-module--success--bMQvE";
export var warning = "styles-module--warning--cgRUu";
export var error = "styles-module--error--2-ITl";
export var icon = "styles-module--icon--w3y8B";